import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faTrashAlt,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import "../AdmissionList/AdmissionList.css";
import AdmissionForm from "../AdmissionForm/AdmissionForm";
import ViewAdmission from "../ViewAdmision/ViewAdmision";
import axios from 'axios'; // Import axios for API requests

function AdmissionList() {
  const [AdmissionListList, setAdmissionListList] = useState([]);
  const [filteredAdmissionList, setFilteredAdmissionList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [classFilter, setClassFilter] = useState("");
  const [addingAdmissionList, setAddingAdmissionList] = useState(false);
  const [editingAdmissionList, setEditingAdmissionList] = useState(null);
  const [viewingAdmissionList, setViewingAdmissionList] = useState(null);
  const [classes, setClasses] = useState([]); // State for dynamic class options

  useEffect(() => {
    // Fetch admission list
    fetch("https://aadyaacademy.org/api/admission")
      .then((response) => response.json())
      .then((data) => {
        setAdmissionListList(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });

    // Fetch class options
    fetch("https://aadyaacademy.org/api/classes")
      .then((response) => response.json())
      .then((data) => {
        setClasses(data.classes || []);
      })
      .catch((error) => {
        console.error("Error fetching classes: ", error);
      });
  }, []);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    let filtered = [...AdmissionListList];

    const formatDobForSearch = (dob) => {
      const date = new Date(dob);
      return `${date.getDate().toString().padStart(2, "0")}/${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}/${date.getFullYear()}`;
    };

    if (searchTerm) {
      filtered = filtered.filter((AdmissionList) => {
        const formattedDob = formatDobForSearch(AdmissionList.dob);
        return (
          AdmissionList.student_name
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          AdmissionList.class_name
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          AdmissionList.gender
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          formattedDob.includes(searchTerm) ||
          AdmissionList.father_name
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          AdmissionList.father_phone
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase())
        );
      });
    }
    if (classFilter) {
      filtered = filtered.filter(
        (AdmissionList) => AdmissionList.class === classFilter
      );
    }

    setFilteredAdmissionList(filtered);
  }, [searchTerm, classFilter, AdmissionListList]);

  const handleCancel = () => {
    setAddingAdmissionList(false);
    setEditingAdmissionList(null);
    setViewingAdmissionList(null);
  };

  const handleDelete = async (id) => {
    try {
      const confirmation = window.confirm("Are you sure you want to delete this student permanently?");
      if (confirmation) {
        // Make the DELETE request to remove the student from the backend
        await axios.delete(`https://aadyaacademy.org/api/admission/${id}`);

        // Remove the student from the local state to reflect changes without refresh
        setAdmissionListList((prevList) =>
          prevList.filter((student) => student.id !== id)
        );

        alert("Student deleted successfully!");
      } else {
        alert("Deletion canceled");
      }
    } catch (error) {
      console.error("Error deleting student: ", error);
      alert("Error deleting student! Please try again.");
    }
  };

  const handleEdit = (AdmissionList) => {
    setEditingAdmissionList(AdmissionList);
    setAddingAdmissionList(true);
  };

  const handleView = (ViewAdmission) => {
    setViewingAdmissionList(ViewAdmission);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${date.getDate().toString().padStart(2, "0")}/${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}/${date.getFullYear()}`;
  };

  if (addingAdmissionList) {
    return (
      <AdmissionForm
        handleCancel={handleCancel}
        editingAdmissionList={editingAdmissionList}
      />
    );
  }

  if (viewingAdmissionList) {
    return (
      <ViewAdmission admission={viewingAdmissionList} onClose={handleCancel} />
    );
  }

  return (
    <div className="AdmissionList">
      <div className="AdmissionList-table">
        <div className="table-header">
          <div className="table-header-top">
            <div className="header-container" style={{ display: "flex", alignItems: "center" }}>
               <h2>Admission List: {filteredAdmissionList.length}</h2>
            </div>
          </div>
          <div className="table-header-btm">
            <input
              type="text"
              className="search-input"
              placeholder="Search"
              value={searchTerm}
              onChange={handleSearch}
            />
            <select
              className="class-filter"
              value={classFilter}
              onChange={(e) => setClassFilter(e.target.value)}
            >
              <option value="">Class</option>
              {classes.map((cls) => (
                <option key={cls.id} value={cls.id}>
                  {cls.name}
                </option>
              ))}
            </select>

            <button
              onClick={() => setAddingAdmissionList(true)}
              className="add-AdmissionList-btn"
            >
              <FontAwesomeIcon icon={faPlus} />
              Add New
            </button>
          </div>
        </div>

        <div className="table-content">
          <table>
            <thead>
              <tr>
                <th className="thead-content">Name</th>
                <th className="thead-content">Class</th>
                <th className="thead-content">Gender</th>
                <th className="thead-content">DOB</th>
                <th className="thead-content">Father's Name</th>
                <th className="thead-content">Father's Email</th>
                <th className="thead-content">Father's Phone</th>
                <th className="thead-content">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredAdmissionList.length === 0 ? (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center" }}>
                    No Admission Lists found
                  </td>
                </tr>
              ) : (
                filteredAdmissionList.map((AdmissionList) => (
                  <tr key={AdmissionList.id}>
                    <td className="tbody-content">
                      {AdmissionList.student_name}
                    </td>
                    <td className="tbody-content">
                      {AdmissionList.class_name}
                    </td>
                    <td className="tbody-content">{AdmissionList.gender}</td>
                    <td className="tbody-content">
                      {formatDate(AdmissionList.dob)}
                    </td>
                    <td className="tbody-content">
                      {AdmissionList.father_name}
                    </td>
                    <td className="tbody-content">
                      {AdmissionList.father_email}
                    </td>
                    <td className="tbody-content">
                      {AdmissionList.father_phone}
                    </td>
                    <td className="actions">
                      <button
                        className="view-btn"
                        onClick={() => handleView(AdmissionList)}
                      >
                        <FontAwesomeIcon icon={faEye} />
                      </button>
                      <button
                        className="edit-btn"
                        onClick={() => handleEdit(AdmissionList)}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                      <button
                        className="delete-btn"
                        onClick={() => handleDelete(AdmissionList.id)} // Use id for deletion
                      >
                        <FontAwesomeIcon icon={faTrashAlt} />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default AdmissionList;
